<div class="page-container" [class.loading]="isLoading">
    <ui-card *ngIf="missingTemplates; else hasTemplate">
        <app-header title="performance.bulk-review.noTemplatesHeader" [back]="true"></app-header>
        <div class="ui divider"></div>
        <p>{{ 'performance.bulk-review.noTemplates' | translate }}</p>
    </ui-card>
    <ng-template #hasTemplate>
        <app-header title="performance.overview.createReview"></app-header>
        <app-steps
            #appSteps
            [steps]="[detailsStep, selectRevieweesStep, participantsStep, summaryStep]"
            [beforeNext]="shouldMoveToNextStep"
            (onPrimary)="onSave()"
        >
            <app-step
                #detailsStep
                [stepForm]="detailsForm"
                [embeddedCard]="false"
                step="performance.bulk-review.reviewInformation"
            >
                <app-form-bulk-review-details
                    #detailsForm
                    [review]="review"
                    [templates]="templates"
                ></app-form-bulk-review-details>
            </app-step>

            <app-step
                #selectRevieweesStep
                [stepForm]="revieweesForm"
                step="performance.bulk-review.selectReviewees.title"
                stepKey="selectReviewees"
            >
                <app-form-bulk-review-reviewees
                    #revieweesForm
                    (onSelectedEmployeesChange)="updateReviewees($event)"
                ></app-form-bulk-review-reviewees>
            </app-step>

            <app-step
                #participantsStep
                [stepForm]="participantsForm"
                step="performance.bulk-review.selectParticipants"
                stepKey="selectParticipants"
                [embeddedCard]="false"
            >
                <app-form-bulk-review-participants
                    #participantsForm
                    [review]="review"
                    [reviewees]="reviewees"
                    (onSelectedParticpantsChange)="updateParticipantsTableList($event)"
                    (onSelectedRevieweesParticpantsListChange)="updateRevieweesParticipantsList($event)"
                ></app-form-bulk-review-participants>
            </app-step>

            <app-step
                #summaryStep
                [stepForm]="summaryForm"
                [embeddedCard]="false"
                step="performance.bulk-review.summary"
            >
                <app-form-bulk-review-summary
                    #summaryForm
                    [review]="review"
                    [reviewees]="reviewees"
                    [participants]="participantsList"
                    [templates]="templates"
                ></app-form-bulk-review-summary>
            </app-step>
        </app-steps>
    </ng-template>
</div>
